import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja';
import 'element-ui/lib/theme-default/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import routes from './routes'
import 'font-awesome/css/font-awesome.min.css'
import * as User from './api/cognitoUser'

Vue.use(ElementUI, { locale });
Vue.use(VueRouter);
Vue.use(Vuex);


const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('token');
    }

    let user = JSON.parse(sessionStorage.getItem('user'));
    let tokens = JSON.parse(sessionStorage.getItem('tokens'));

    if (to.path === "/login") {
        next();
    } else if ((!user || !tokens)) {
        // tokenがなかったらログイン画面へ
        next({ path: '/login' });
    } else {
        // 管理者はそのまま、ユーザは特定ページへ
        const attributes = JSON.parse(sessionStorage.getItem('attributes'));
        if ("custom:isAdmin" in attributes && attributes["custom:isAdmin"] === "true") {
            // 管理者ユーザ、又は 一般ユーザ用のルートの場合はスルー
            if (User.checkAdminRoleBySession() || User.isGeneralRoute(to.path)) {
                next();
            } else {
                // 一般ユーザ、且つ 一般ユーザ用のパスではない場合は一般ユーザ用のパスに飛ばす
                next({ path: "/contents/movies"});
            }
        } else {
            if (to.path === "/users/contents") {
                next();
            } else {
                next({ path: "/users/contents" });
            }
        }
    }
});

router.afterEach(transition => {
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js